import React, { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useGetAPIWithoutTokenQuery } from '../Api/api';
import { READ_EVENT_THEME } from '../Api/apiConstant';
export const ThemeColorContext = createContext();

export const ThemeColorContextProvider = ({ children, eventId: propEventId }) => {
  const reduxEventId = useSelector((state) => state.currentEvent.eventId);
  const eventId =
    propEventId !== undefined ? propEventId : window.location.pathname === '/' ? 0 : reduxEventId;

  const { data } = useGetAPIWithoutTokenQuery(`${READ_EVENT_THEME}?event_id=${eventId || 0}`);
  const primaryColor = data?.data[0]?.primary_color;
  const secondaryColor = data?.data[0]?.secondary_color;
  const textColor = data?.data[0]?.text_color;
  const buttonColor = data?.data[0]?.button_color;
  const buttonTextColor = data?.data[0]?.button_text_color;
  const backgroundColor = data?.data[0]?.background_color;
  const logo = data?.data[0]?.logo_path;
  const fontFamily = data?.data[0]?.font_family;
  const fontWeight = data?.data[0]?.font_weight;
  const fontSize = data?.data[0]?.font_size;
  const fontFamilyHeading = data?.data[0]?.font_family_heading;
  const fontWeightHeading = data?.data[0]?.font_weight_heading;
  const fontSizeHeading = data?.data[0]?.font_size_heading;

  return (
    <ThemeColorContext.Provider
      value={{
        primaryColor,
        secondaryColor,
        textColor,
        buttonColor,
        buttonTextColor,
        backgroundColor,
        logo,
        fontFamily,
        fontWeight,
        fontSize,
        fontFamilyHeading,
        fontWeightHeading,
        fontSizeHeading,
      }}
    >
      {children}
    </ThemeColorContext.Provider>
  );
};

export const useThemeColors = () => useContext(ThemeColorContext);
